const { TEXT_TYPE } = require('vqua/lib/constants/nodeTypes')

module.exports = (node) => {

  return {
    type: TEXT_TYPE,
    text: node.textContent,
    dom: node,
  }

}



// WEBPACK FOOTER //
// ../node_modules/dom2vqua/lib/convertText.js